import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isMobileApp } from '../../utils/mobile';
import { App } from "@capacitor/app";
import {
  PushNotifications
} from "@capacitor/push-notifications";

// URL syncing implmented by useNavigate() from react-router-dom thus this
// component must be rendered inside the <Router> component.
export const DeepLinksNavigation: React.FC = () => {
    const navigate = useNavigate();

    const getRelativePath = (url: string) => {
        const parsedUrl = new URL(url);
        return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
    };

    React.useEffect(() => {
        if (isMobileApp) {
            App.addListener("appUrlOpen", ({ url }) =>
                navigate(getRelativePath(url)),
            );

            PushNotifications.addListener(
                "pushNotificationActionPerformed",
                (action) => {
                    const url = action?.notification?.data?.url;

                    if (url) {
                        navigate(getRelativePath(url));
                    }
                },
            );
        }
    }, []);

    return null;
};